<template>
  <div>
    <vs-card>
      <vs-row v-if="dadosResult">
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="12"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-card
            ><div slot="header">
              <h3>Dados do Cancelamento</h3>
            </div>
            <table class="table table-bordered">
              <tr>
                <th class="uppercase">Motivo</th>
                <th class="uppercase">Placa</th>
                <th class="uppercase">Criador</th>
                <th class="uppercase">Responsável</th>
                <th class="uppercase">Retido</th>
                <th class="uppercase">Status</th>
              </tr>
              <tr>
                <td>{{ dadosResult.cancelamento.motivo }}</td>
                <td>{{ dadosResult.cancelamento.placa }}</td>
                <td>{{ dadosResult.cancelamento.usuarioCriador }}</td>
                <td>{{ dadosResult.cancelamento.usuarioResponsavel }}</td>
                <td>{{ dadosResult.cancelamento.retido }}</td>
                <td>{{ dadosResult.cancelamento.status }}</td>
              </tr>
            </table>
          </vs-card>
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          vs-sm="6"
          vs-xs="12"
        >
          <vs-card
            ><div slot="header">
              <h3>Dados do Beneficiário</h3>
            </div>
            <table class="table table-bordered">
              <tr>
                <th class="uppercase">Nome</th>
                <td>{{ dadosResult.associado.nome }}</td>
              </tr>
              <tr>
                <th class="uppercase">Email</th>
                <td>{{ dadosResult.associado.email }}</td>
              </tr>
              <tr>
                <th class="uppercase">CPF/CNPJ</th>
                <td>{{ dadosResult.associado.cpfcnpj }}</td>
              </tr>
              <tr>
                <th class="uppercase">Telefone</th>
                <td>{{ dadosResult.associado.telefone }}</td>
              </tr>
              <tr>
                <th class="uppercase">Celular</th>
                <td>{{ dadosResult.associado.celular }}</td>
              </tr>
              <tr>
                <th class="uppercase">Cep</th>
                <td>{{ dadosResult.associado.cep }}</td>
              </tr>
              <tr>
                <th class="uppercase">Endereço</th>
                <td>
                  {{ dadosResult.associado.endereco }},
                  {{ dadosResult.associado.numero }}
                  {{ dadosResult.associado.complemento }}<br />
                  {{ dadosResult.associado.bairro }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Cidade / UF</th>
                <td>
                  {{ dadosResult.associado.cidade }} /
                  {{ dadosResult.associado.estado }}
                </td>
              </tr>
            </table>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          vs-sm="6"
          vs-xs="12"
        >
          <vs-card
            ><div slot="header">
              <h3>Dados do Veículo</h3>
            </div>
            <table class="table table-bordered">
              <tr>
                <th class="uppercase">Placa</th>
                <td>{{ dadosResult.veiculo.placa }}</td>
              </tr>
              <tr>
                <th class="uppercase">Categoria</th>
                <td>{{ dadosResult.veiculo.categoria }}</td>
              </tr>
              <tr>
                <th class="uppercase">Marca</th>
                <td>{{ dadosResult.veiculo.marca }}</td>
              </tr>
              <tr>
                <th class="uppercase">Modelo</th>
                <td>{{ dadosResult.veiculo.modelo }}</td>
              </tr>
              <tr>
                <th class="uppercase">Ano</th>
                <td>
                  {{ dadosResult.veiculo.ano_fabricacao }} /
                  {{ dadosResult.veiculo.ano_modelo }}
                </td>
              </tr>
              <tr>
                <th class="uppercase">Fipe</th>
                <td>{{ dadosResult.veiculo.codigo_fipe }}</td>
              </tr>
              <tr>
                <th class="uppercase">Chassi</th>
                <td>{{ dadosResult.veiculo.chassi }}</td>
              </tr>
              <tr>
                <th class="uppercase">Renavam</th>
                <td>{{ dadosResult.veiculo.renavam }}</td>
              </tr>
              <tr>
                <th class="uppercase">Situação</th>
                <td>{{ dadosResult.veiculo.descricao_situacao }}</td>
              </tr>
            </table>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          vs-sm="6"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Boletos</h3>
            </div>
            <div
              v-if="dadosResult.boletos.length == 0"
              class="bg-danger text-white p-3"
            >
              Nenhum boleto encontrado
            </div>
            <div v-else>
              <table
                v-for="item in dadosResult.boletos"
                :key="item.id"
                class="table table-bordered tableboletos"
              >
                <tr>
                  <th>Tipo</th>
                  <th>Situação</th>
                  <th>Vencimento</th>
                </tr>
                <tr>
                  <td>{{ item.tipo_boleto }}</td>
                  <td>{{ item.situacao_boleto }}</td>
                  <td>{{ formataData(item.data_vencimento) }}</td>
                </tr>
                <tr>
                  <td colspan="3" v-if="item.situacao_boleto == 'ABERTO'">
                    Linha {{ item.linha_digitavel }}
                  </td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          vs-sm="6"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Produtos</h3>
            </div>
            <div
              v-if="dadosResult.produtos.length == 0"
              class="bg-danger text-white p-3"
            >
              Nenhum Produto encontrado
            </div>
            <div v-else>
              <table class="table table-bordered">
                <tr>
                  <th>Produto</th>
                  <th>Valor</th>
                </tr>
                <tr v-for="item in dadosResult.produtos" :key="item.id">
                  <td>{{ item.descricao }}</td>
                  <td>{{ item.valor | currency }}</td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          vs-sm="6"
          vs-xs="12"
        >
          <vs-card>
            <div slot="header">
              <h3>Respostas</h3>
            </div>
            <div
              v-if="dadosResult.respostas.length == 0"
              class="bg-danger text-white p-3"
            >
              Nenhuma Resposta encontrado
            </div>
            <div v-else>
              <table class="table table-bordered">
                <tr>
                  <th>Pergunta</th>
                  <th>Resposta</th>
                </tr>
                <tr v-for="item in dadosResult.respostas" :key="item.id">
                  <td>{{ item.pergunta }}</td>
                  <td>{{ item.resposta }}</td>
                </tr>
              </table>
            </div>
          </vs-card>
        </vs-col>

        <vs-col
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
          vs-w="6"
          vs-sm="6"
          vs-xs="12"
        >
          <vs-row>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-card>
                <div slot="header">
                  <h3>Termos</h3>
                </div>
                <div
                  v-if="dadosResult.termos.length == 0"
                  class="bg-danger text-white p-3"
                >
                  Nenhum Termo encontrado
                </div>
                <div v-else>
                  <table class="table table-bordered">
                    <tr>
                      <th>Termo</th>
                      <th>Assinatura</th>
                      <th></th>
                    </tr>
                    <tr v-for="item in dadosResult.termos" :key="item.id">
                      <td>{{ item.tipoContrato }}</td>
                      <td>
                        {{
                          item.assinatura == null
                            ? 'não'
                            : 'sim em ' + formataDataHora(item.dataAssinatura)
                        }}
                      </td>
                      <td>
                        <vs-button
                          v-if="item.assinatura != null"
                          @click="verTermo(item)"
                          color="success"
                          class="m-3"
                          icon-pack="feather"
                          icon="icon-search"
                        >
                          <span></span>
                        </vs-button>
                      </td>
                    </tr>
                  </table>
                </div>
              </vs-card>
            </vs-col>

            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
              vs-sm="12"
              vs-xs="12"
            >
              <vs-card>
                <div slot="header">
                  <h3>Chamados Internos</h3>
                </div>
                <div
                  v-if="dadosResult.chamados.length == 0"
                  class="bg-danger text-white p-3"
                >
                  Nenhum Chamado encontrado
                </div>
                <div v-else>
                  <table class="table table-bordered">
                    <tr>
                      <th>ID</th>
                      <th>Responsável</th>
                      <th>Titulo</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                    <tr v-for="item in dadosResult.chamados" :key="item.id">
                      <td>{{ item.id_chamado }}</td>
                      <td>{{ item.responsavel }}</td>
                      <td>{{ item.titulo }}</td>
                      <td>{{ item.status }}</td>
                      <td>
                        <vs-button
                          @click="verChamado(item.id_chamado)"
                          color="success"
                          class="m-3"
                          icon-pack="feather"
                          icon="icon-search"
                        >
                          <span></span>
                        </vs-button>
                      </td>
                    </tr>
                  </table>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-card>
    <vs-popup
      :title="'Assinatura de Termo'"
      @close="popTermo = false"
      :active.sync="popTermo"
    >
      <div v-if="itemPop" class="con-exemple-prompt">
        <h3>{{ itemPop.tipoContrato }}</h3>
        <hr />
        <div v-html="itemPop.termoPreenchido" class="my-4"></div>
        <div class="text-center p-2">
          <img :src="itemPop.assinatura" height="200" />
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import locale from './../../../locale';
import moment from 'moment';
import swal from 'sweetalert';
import service from './../../../services';

export default {
  data() {
    return {
      realizaFiltro: false,
      filtro: null,
      dadosResult: null,
      popTermo: false,
      itemPop: null,
    };
  },
  methods: {
    verChamado(id) {
      console.log(`editarChamadoInterno/${id}`);
      //this.$router.push("/NovoCancelamento");
      this.$router.push(`/editarChamadoInterno/${id}`);
    },
    verTermo(item) {
      this.itemPop = item;
      this.popTermo = true;
    },
    makeFiltro(filtro) {
      this.realizaFiltro = true;
      this.filtro = filtro;
    },
    finalizaFiltro() {
      this.realizaFiltro = false;
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY');
    },
    formataDataHora(data) {
      return moment(data).format('DD/MM/YYYY HH:mm:SS');
    },
    buscarDados() {
      var objSend = {};
      objSend.idCancelamento = this.$route.params.idCancelamento;
      this.$vs.loading();
      service
        .post('Cancelamento', 'BuscarDetalheCancelamento', objSend)
        .then((res) => {
          this.dadosResult = res.data;
          console.log(res.data);
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.log(error);
          this.dadosResult = null;
          this.$vs.loading.close();
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: error,
            color: 'danger',
          });
        });
    },
  },
  mounted() {
    this.buscarDados();
    this.$validator.localize('ptBr', locale);
  },
  components: {},
};
</script>

<style lang="scss">
.con-vs-popup .vs-popup {
  width: 635px !important;
}
.table-bordered {
  display: table;
  border-collapse: separate;
  box-sizing: border-box;
  border-spacing: 2px;
  border-color: grey;
  width: 100%;
  tr td {
    padding: 2px;
  }
  tr:nth-child(2n) {
    background: #efefef !important;
  }
}

.tableboletos {
  tr td {
    width: 33%;
  }
  tr:nth-child(1) th {
    display: none;
  }
}
.tableboletos:nth-child(1) {
  tr:nth-child(1) th {
    display: table-cell;
  }
}
</style>
